import React, { useEffect, useState } from 'react';
import api from '../../services/api';

const inputClass = 'w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500';

export default function StudentProfile() {
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ civilite: '', phone: '', adresse: '', emailParent: '' });
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/auth/me').then(res => {
      setProfile(res.data);
      setForm({
        civilite: res.data.civilite || '',
        phone: res.data.phone || '',
        adresse: res.data.adresse || '',
        emailParent: res.data.emailParent || '',
      });
    }).catch(console.error);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccess(false);
    setError('');
    try {
      await api.put('/auth/profile', form);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (!profile) return <div className="text-gray-500 text-sm py-8">Chargement...</div>;

  return (
    <div className="max-w-lg">
      <h2 className="text-xl font-semibold text-gray-800 mb-6">Mon profil</h2>

      {/* Données en lecture seule */}
      <div className="bg-white rounded-xl border border-gray-200 p-5 mb-5">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-3">Informations administratives</p>
        <div className="space-y-2 text-sm text-gray-700">
          <div className="flex justify-between">
            <span className="text-gray-500">Nom</span>
            <span className="font-medium">{profile.firstName} {profile.lastName}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">INE</span>
            <span className="font-medium font-mono">{profile.ine || '—'}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Date de naissance</span>
            <span className="font-medium">
              {profile.dateNaissance ? new Date(profile.dateNaissance).toLocaleDateString('fr-FR') : '—'}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Email</span>
            <span className="font-medium">{profile.email || '—'}</span>
          </div>
        </div>
      </div>

      {/* Données modifiables */}
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-4">Coordonnées</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Civilité</label>
            <select value={form.civilite} onChange={e => setForm(p => ({ ...p, civilite: e.target.value }))} className={inputClass}>
              <option value="">—</option>
              <option value="M.">M.</option>
              <option value="Mme">Mme</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Téléphone</label>
            <input type="tel" value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))}
              className={inputClass} placeholder="ex: 06 12 34 56 78" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Adresse</label>
            <input type="text" value={form.adresse} onChange={e => setForm(p => ({ ...p, adresse: e.target.value }))}
              className={inputClass} placeholder="ex: 12 rue des Lilas, 75001 Paris" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Email parent / responsable légal</label>
            <input type="email" value={form.emailParent} onChange={e => setForm(p => ({ ...p, emailParent: e.target.value }))}
              className={inputClass} placeholder="ex: parent@email.fr" />
          </div>

          {error && <p className="text-red-600 text-sm">{error}</p>}
          {success && <p className="text-green-600 text-sm">Modifications enregistrées.</p>}

          <button type="submit" disabled={saving}
            className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors">
            {saving ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </form>
      </div>
    </div>
  );
}
